/**
 * @generated SignedSource<<abd04294ff006b2202bcf9328bc5a372>>
 * @relayHash ad050f15d39cbc9d3aafcc8b9e6d6de1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8214743d53b457ed286f5f31167af6656f632a210092a4f08c0e4c132b5ce3b9

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type CommentResolveInlineCommentMutation$variables = {
  commentId: string;
  resolved: boolean;
};
export type CommentResolveInlineCommentMutation$data = {
  readonly resolveInlineComment: {
    readonly resolveProperties: {
      readonly isDangling: boolean;
      readonly resolved: boolean;
      readonly resolvedFriendlyDate: string | null | undefined;
      readonly resolvedTime: AGG$Long | null | undefined;
      readonly resolvedUser: string | null | undefined;
    } | null | undefined;
    readonly status: boolean;
  } | null | undefined;
};
export type CommentResolveInlineCommentMutation = {
  response: CommentResolveInlineCommentMutation$data;
  variables: CommentResolveInlineCommentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "commentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "resolved"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "commentId",
        "variableName": "commentId"
      },
      {
        "kind": "Literal",
        "name": "dangling",
        "value": false
      },
      {
        "kind": "Variable",
        "name": "resolved",
        "variableName": "resolved"
      }
    ],
    "concreteType": "ResolveInlineCommentPayload",
    "kind": "LinkedField",
    "name": "resolveInlineComment",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "status"
      },
      {
        "concreteType": "InlineCommentResolveProperties",
        "kind": "LinkedField",
        "name": "resolveProperties",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "resolved"
          },
          {
            "kind": "ScalarField",
            "name": "resolvedUser"
          },
          {
            "kind": "ScalarField",
            "name": "isDangling"
          },
          {
            "kind": "ScalarField",
            "name": "resolvedFriendlyDate"
          },
          {
            "kind": "ScalarField",
            "name": "resolvedTime"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "CommentResolveInlineCommentMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CommentResolveInlineCommentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ad050f15d39cbc9d3aafcc8b9e6d6de1",
    "id": "8214743d53b457ed286f5f31167af6656f632a210092a4f08c0e4c132b5ce3b9",
    "metadata": {},
    "name": "CommentResolveInlineCommentMutation",
    "operationKind": "mutation",
    "text": "mutation CommentResolveInlineCommentMutation($commentId:ID!,$resolved:Boolean!){resolveInlineComment(commentId:$commentId,resolved:$resolved,dangling:false){status,resolveProperties{resolved,resolvedUser,isDangling,resolvedFriendlyDate,resolvedTime}}}"
  }
};
})();

(node as any).hash = "1e1b3569fe182ba794f3ff37bb47f03f";

export default node;
